module.exports = __webpack_public_path__ + "static/media/Garn-min.9999d498.PNG";